/* eslin/t-disable promise/param-names */

const AUTHTOKEN_REQUEST = "AUTHTOKEN_REQUEST";
const AUTHTOKEN_SUCCESS = "AUTHTOKEN_SUCCESS";
const AUTHTOKEN_ASSUMED = "AUTHTOKEN_ASSUMED";
const AUTHTOKEN_ERROR = "AUTHTOKEN_ERROR";
const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const USERPROFILE_REQUEST = "USERPROFILE_REQUEST";

import Vue from "vue";
import Snotify, { SnotifyPosition } from 'vue-snotify'
import router from '../../router'

const options = {
    toast: {
        position: SnotifyPosition.leftTop,
    }
}
function showSnotifyWarning(theMessage) {
    Vue.prototype.$snotify.warning(theMessage, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
    });
}
Vue.use(Snotify,options)

const state = {
    token: localStorage.getItem("user-token") || sessionStorage.getItem("user-token") || "",
    status: "",
    hasLoadedOnce: false
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    getAuthToken: state => state.token
};

const actions = {
    [AUTHTOKEN_REQUEST]: ({ commit, dispatch, getters }, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTHTOKEN_REQUEST);
            commit('addLoading', {handle:'authtoken',name:'Get Auth Token'})

 
            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            };
                        
            fetch(Vue.prototype.$apiServer + 'login', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'authtoken')
                        if (resp.result === 'Success') {
                            if(getters.rememberLoading === true) {
                                localStorage.setItem("user-token", resp.payload.token);
                            } else {
                                sessionStorage.setItem("user-token", resp.payload.token);
                            }

                            Vue.prototype.$token = resp.payload.token;
                            commit(AUTHTOKEN_SUCCESS, resp.payload.token);
                            dispatch(USERPROFILE_REQUEST);
                            resolve(resp)
                        } else {
                            commit(AUTHTOKEN_ERROR);
                            response.json().then(err => {
                                reject(err)
                            })
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'authtoken')
                    
                    localStorage.removeItem("user-token");
                    sessionStorage.removeItem("user-token");
                    Vue.prototype.$token = '';
                    commit(AUTHTOKEN_ERROR)
                    response.json().then(err => {
                        reject(err)
                    })
                }
            }) 
        });
    },
    [AUTHTOKEN_LOGOUT]: ({ commit }) => {
        if(sessionStorage.getItem("user-token")) {
            sessionStorage.removeItem("user-token");
        }
        if(localStorage.getItem("user-token")) {
            localStorage.removeItem("user-token");
        }
        commit(AUTHTOKEN_LOGOUT);
        Vue.prototype.$token = '';
        if(router.currentRoute.path !== '/login'){
            router.push('/login');
        }
        showSnotifyWarning("You have been logged out.");
    }
};

const mutations = {
    [AUTHTOKEN_REQUEST]: state => {
        state.status = "loading";
    },
    [AUTHTOKEN_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.token = resp;
        state.hasLoadedOnce = true;
    },
    [AUTHTOKEN_ASSUMED]: (state, resp) => {
        state.status = "assumed";
        state.token = resp;
    },
    [AUTHTOKEN_ERROR]: state => {
        state.status = "error";
        state.hasLoadedOnce = true;
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.token = "";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};